export default __webpack_public_path__ + "static/media/heart.034ab291.svg";